import { FunctionComponent } from "react";

export type HugeNumberProps = {
    number: number;
};

const formatter = new Intl.NumberFormat("cs", {
    maximumFractionDigits: 0,
});

const colors = [
    "#69f0ae",
    "#b2ff59",
    "#ffeb3b",
    "#ffb74d",
    "#ff8a65",
    "#ff5252",
]

export const HugeNumber: FunctionComponent<HugeNumberProps> = ({ number }) => {
    const parts = formatter.formatToParts(number);
    const numberParts = Math.round(parts.length / 2);

    return (
        <span>
            {parts.map((part, index) => {
                const colorIndex = Math.floor(index / 2)
                return (
                    <span key={index} style={{ color: colors[numberParts - colorIndex - 1] }}>{part.value}</span>
                )
            })}+
        </span>
    )
};
